import script from "./AssetsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsView.vue?vue&type=script&setup=true&lang=js"

import "./AssetsView.vue?vue&type=style&index=0&id=57bbcfdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57bbcfdb"]])

export default __exports__